export const aboutData = {
  brandName: '琴韵阁',
  tagline: '传承六角琴艺，弘扬国乐之美',
  intro: '琴韵阁成立于2008年，是国内首家专注于六角琴文化传播与教育的专业平台。十余年来，我们致力于六角琴的教学研究、内容创作与乐器评测，已累计服务超过50万名六角琴爱好者。我们与国内外多家知名制琴工坊深度合作，为学习者提供从入门到专业演奏的全阶段学习资源。',
  story: '创始人张清韵先生出身音乐世家，自幼研习多种民族乐器。2005年，他在一次民间采风中首次接触到六角琴，被其独特造型与清亮音色深深吸引。然而当时市面上关于六角琴的学习资料极为匮乏，他决心创办琴韵阁，填补这一空白。经过十八年的深耕，琴韵阁已成为国内六角琴领域最具影响力的专业内容平台。',
  values: [
    { title: '专业严谨', description: '所有教程与评测内容均由资深演奏家与专业教师团队审核把关，确保信息准确、教学科学。', icon: 'ri-shield-check-line' },
    { title: '传承创新', description: '在尊重传统的基础上，积极探索六角琴与现代音乐的融合，让古老乐器焕发新生。', icon: 'ri-lightbulb-line' },
    { title: '用户至上', description: '以学习者的需求为核心，持续优化内容和服务，让每位爱好者都能找到适合自己的学习路径。', icon: 'ri-heart-line' },
  ],
  stats: [
    { value: '50万+', label: '服务用户' },
    { value: '1200+', label: '原创文章' },
    { value: '18年', label: '深耕行业' },
    { value: '98%', label: '好评率' },
  ],
  testimonials: [
    { name: '李女士', role: '六角琴教师', content: '琴韵阁的教程系统专业，从指法基础到曲目演绎，每一篇文章都让我受益匪浅。我经常推荐给我的学生阅读。', rating: 5 },
    { name: '王先生', role: '业余爱好者', content: '通过琴韵阁的选购指南，我买到了人生第一把六角琴。内容详实、客观，帮我省了不少冤枉钱。', rating: 5 },
    { name: '陈同学', role: '音乐学院学生', content: '历史起源系列文章写得非常深入，为我撰写论文提供了宝贵的参考资料。强烈推荐给每一位六角琴学习者。', rating: 5 },
  ],
  contact: {
    email: 'contact@qinyunge.com',
    phone: '400-888-6666',
    address: '北京市朝阳区建国路88号音乐大厦12层',
    wechat: 'qinyunge_official',
  },
};

export const reputationItems = [
  {
    icon: 'ri-award-line',
    title: '行业权威认证',
    description: '中国民族管弦乐学会推荐学习平台，获评"优秀民族音乐教育机构"。',
  },
  {
    icon: 'ri-team-line',
    title: '专业师资团队',
    description: '汇聚中央音乐学院、中国音乐学院等高校的资深演奏家与教育专家。',
  },
  {
    icon: 'ri-article-line',
    title: '丰富内容资源',
    description: '涵盖入门教程、演奏技巧、选购指南等全品类原创内容，持续更新中。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心售后服务',
    description: '7×12小时在线客服，选购咨询、售后问题快速响应，让您无后顾之忧。',
  },
];